<template>
    <el-dialog :close-on-click-modal="false" :visible.sync="visible" class="h-dialog2 batch-modify-dialog" width="800px" @close="handleClose">
        <div class="h-dialogImg">
            <div class="h-disTable">
                <div class="h-tableCell">
                    <h1>{{ mode === 'detail' ? '批次详情' : '批量修改型号经理' }}</h1>
                </div>
            </div>
        </div>

        <!-- 新增模式：显示查询条件 -->
        <div v-if="mode !== 'detail'" class="h-formLine">
            <el-form :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                <el-form-item label="查询条件" class="h-elformWrap-1">
                    <div style="display: flex; gap: 10px;">
                        <el-input v-model="queryValue" placeholder="请输入型号经理编码或产品编码" style="width: 300px;"></el-input>
                        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="searchByManager">按型号经理增加</el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" @click="searchByMaterialCode">按产品编码增加</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <!-- 详情模式：显示批次信息 -->
        <div v-if="mode === 'detail'" style="margin-bottom: 15px; padding: 10px;">
            <span>批次号：{{ detailBatchNo }}</span>
            <span style="margin-left: 20px;">目标型号经理：{{ detailNewUserName }}（{{ detailNewUserCode }}）</span>
        </div>

        <el-table :data="selectedList" border style="width: 100%; margin-bottom: 15px;" max-height="400">
            <el-table-column type="index" label="#" width="50"></el-table-column>
            <el-table-column prop="materialName" label="物料名称" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="materialCode" label="物料编码" min-width="120"></el-table-column>
            <el-table-column prop="cpdlName" label="产品大类" width="120"></el-table-column>
            <el-table-column prop="oldUserCode" label="原型号经理编码" min-width="120"></el-table-column>
            <el-table-column prop="oldUserName" label="原型号经理名称" min-width="120"></el-table-column>
            <!-- 新增模式：显示操作列 -->
            <el-table-column v-if="mode !== 'detail'" label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="removeRow(scope.$index)" style="color: #F56C6C;">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 新增模式：显示清空按钮 -->
        <div v-if="mode !== 'detail'" style="margin-bottom: 15px; display: flex; align-items: center; justify-content: flex-end; padding-right: 10px;">
            <span style="margin-right: 10px; color: #999;">共 {{ selectedList.length }} 条记录</span>
            <el-button class="h-btn h-formBtn h-bgred" size="small" @click="clearAll" :disabled="selectedList.length === 0">清空列表</el-button>
        </div>

        <!-- 详情模式：显示记录数 -->
        <div v-if="mode === 'detail'" style="margin-bottom: 15px; padding: 0 10px; color: #999; text-align: right;">
            共 {{ selectedList.length }} 条记录
        </div>

        <!-- 新增模式：显示目标型号经理选择 -->
        <el-form v-if="mode !== 'detail'" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
            <el-form-item label="目标型号经理" class="h-elformWrap-2" required>
                <el-select
                    v-model="targetUser"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入姓名搜索"
                    :remote-method="searchTargetUser"
                    :loading="false"
                    value-key="userCode"
                    style="width: 100%;">
                    <el-option
                        v-for="item in userList"
                        :key="item.usercode"
                        :label="item.username + '-' + item.usercode"
                        :value="{ userCode: item.usercode, userName: item.username }">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button class="h-btn h-formBtn h-bgwhite" @click="handleClose">{{ mode === 'detail' ? '关 闭' : '取 消' }}</el-button>
            <el-button v-if="mode !== 'detail'" class="h-btn h-formBtn h-bgblueQ2" @click="handleSubmit">提交修改</el-button>
        </div>
    </el-dialog>
</template>

<script>
import batchModifyManager from '@/api/chanpin/batchModifyManager'
import ss from '@/api/SystemService'

export default {
    name: 'BatchModifyManagerDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: 'add' // 'add' 新增模式, 'detail' 详情模式
        },
        detailBatchNo: {
            type: String,
            default: ''
        },
        detailNewUserCode: {
            type: String,
            default: ''
        },
        detailNewUserName: {
            type: String,
            default: ''
        },
        detailData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            queryValue: '',
            selectedList: [],
            targetUser: null,
            userList: []
        }
    },
    watch: {
        visible(val) {
            if (val) {
                if (this.mode === 'detail' && this.detailData.length > 0) {
                    this.selectedList = this.detailData
                } else if (this.mode === 'add') {
                    this.initData()
                }
            }
        }
    },
    methods: {
        // 初始化数据
        initData() {
            this.queryValue = ''
            this.selectedList = []
            this.targetUser = null
            this.userList = []
        },

        // 关闭弹窗
        handleClose() {
            this.$emit('update:visible', false)
        },

        // 按型号经理查询
        searchByManager() {
            if (!this.queryValue) {
                this.$msg.msge('请输入型号经理编码或名称')
                return
            }
            let params = {
                oldUserCode: this.queryValue
            }
            batchModifyManager.selectProjingliByCondition(params).then(rd => {
                if (rd.f && rd.obj && rd.obj.length > 0) {
                    this.addToList(rd.obj)
                } else {
                    this.$msg.msge('未查询到相关数据')
                }
            })
        },

        // 按产品编码查询
        searchByMaterialCode() {
            if (!this.queryValue) {
                this.$msg.msge('请输入产品编码')
                return
            }
            let params = {
                materialCode: this.queryValue
            }
            batchModifyManager.selectProjingliByCondition(params).then(rd => {
                if (rd.f && rd.obj && rd.obj.length > 0) {
                    this.addToList(rd.obj)
                } else {
                    this.$msg.msge('未查询到相关数据')
                }
            })
        },

        // 添加到已选列表（去重）
        addToList(data) {
            let newItems = []
            for (let item of data) {
                let exists = this.selectedList.some(s => s.projingliId === item.projingliId)
                if (!exists) {
                    newItems.push({
                        projingliId: item.projingliId,
                        materialCode: item.materialCode,
                        materialName: item.materialName,
                        cpdlName: item.cpdlName || '',
                        oldUserCode: item.oldUserCode,
                        oldUserName: item.oldUserName || item.oldUserCode
                    })
                }
            }
            this.selectedList = [...this.selectedList, ...newItems]
            this.queryValue = ''
            this.$msg.msgs('已添加 ' + newItems.length + ' 条记录')
        },

        // 删除单行
        removeRow(index) {
            this.selectedList.splice(index, 1)
        },

        // 清空列表
        clearAll() {
            this.selectedList = []
        },

        // 远程搜索目标型号经理
        searchTargetUser(query) {
            if (query) {
                ss.MuBiao.selectUser(query).then(res => {
                    this.userList = res.obj || []
                })
            }
        },

        // 提交批量修改
        handleSubmit() {
            if (!this.targetUser || !this.targetUser.userCode) {
                this.$msg.msge('请选择目标型号经理')
                return
            }
            if (this.selectedList.length === 0) {
                this.$msg.msge('请添加需要修改的产品')
                return
            }

            let submitData = this.selectedList.map(item => {
                return {
                    ...item,
                    newUserCode: this.targetUser.userCode,
                    newUserName: this.targetUser.userName
                }
            })

            this.$confirm('确认提交批量修改？共 ' + submitData.length + ' 条记录', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                batchModifyManager.submit(submitData).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs('提交成功，批次号：' + rd.obj)
                        this.handleClose()
                        this.$emit('success')
                    } else {
                        this.$msg.msge(rd.msg || '提交失败')
                    }
                })
            }).catch(() => {})
        }
    }
}
</script>

<style>
/* 批量修改型号经理弹窗样式 */
.batch-modify-dialog .h-dialogImg {
    height: 1.62rem;
    background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.batch-modify-dialog .h-dialogImg h1 {
    font-size: 0.3rem;
    color: #fff;
    font-weight: normal;
    letter-spacing: 0.02rem;
}

.batch-modify-dialog .h-mrb-38 {
    margin-bottom: 0.2rem;
}

.batch-modify-dialog .el-table {
    width: 100% !important;
}

.batch-modify-dialog .h-elformWrap-1 {
    width: 100%;
}

.batch-modify-dialog .h-elformWrap-2 {
    width: 50%;
}

.batch-modify-dialog .el-select {
    width: 100%;
}
</style>